/**
 * 
 */
(function() {
	angular.module("cbl.finanza.mf").service("FinPaginatoreSrvc", [ function() {

		this.itemsPerPage = 10;
		this.pageNumber = 1;
		this.maxSize = 5;

		self = this;

		this.init = function() {
			self.itemsPerPage = 10;
			self.pageNumber = 1;
			self.maxSize = 5;
			self.listaFiltrata = null;
		}

	} ]);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/servicesUtilities/finPaginatoreSrvc.js
 ** module id = 25
 ** module chunks = 0 1 2
 **/